export function countWords(str) {
  if (!str || str === "") {
    return null;
  }
  const words = str.trim().split(/\s+/).filter(word => word !== '');

  // Verifica se não há texto
  if (words.length === 1 && words[0] === '') {
    return null;
  }

  // Conta o número de palavras
  const wordCount = words.length;

  return wordCount;
}